export const ToastId = {
  MANAGER_CHANGE: { toastId: "success-manager-change" },
  MANAGER_REQUEST: { toastId: "success-manager-change-request" },
  ERROR_ACTIVE_EMPLOYEE: { toastId: "error-active-employee-change" },
  AREA_CHANGE: { toastId: "success-area-change" },
  POSITION_CHANGE: { toastId: "success-position-change" }
};
